import { apiClient } from '../../../helpers/apiHelperV2';
import { FETCH_PRODUCT_FAILURE, FETCH_PRODUCT_REQUEST, FETCH_PRODUCT_SUCCESS, SET_PRODUCT_VARIANT_ID } from '../../actionTypes';
import { standortUrlSelector } from '../../selectors/url';
import { productResponseSelector } from '../../selectors/standort/vehicleFilter/product';
import { shouldFetch } from '../../fetchStatus';
import { markenStandortSelector } from '../../selectors/standort/markenStandort';
import { datECodePrefixSelector } from '../../selectors/vehicle';

export const fetchProductIfNeeded = ({ categoryUrl, productUrl, isExact }) => {
    return async function (dispatch, getState) {
        const state = getState();

        const standortUrl = standortUrlSelector(state);
        const markenStandort = markenStandortSelector(state);
        const productResponse = productResponseSelector(state, { categoryUrl, productUrl });
        const datECodePrefix = datECodePrefixSelector(state);

        if (shouldFetch(productResponse.status)) {
            dispatch({
                type: FETCH_PRODUCT_REQUEST,
                payload: { standortUrl, categoryUrl, productUrl, isExact, datECodePrefix },
            });
            try {
                const res = await apiClient.get(
                    `/api/v1/standorte/${standortUrl}/categories/${encodeURIComponent(categoryUrl)}/products/${encodeURIComponent(
                        productUrl
                    )}`,
                    {
                        params: {
                            datECodePrefix,
                        },
                    }
                );
                dispatch({
                    type: FETCH_PRODUCT_SUCCESS,
                    payload: {
                        standortUrl,
                        categoryUrl,
                        productUrl,
                        isExact,
                        datECodePrefix,
                        data: res.data,
                        fabrikat: markenStandort.hauptFabrikat,
                    },
                });
            } catch (error) {
                dispatch({
                    type: FETCH_PRODUCT_FAILURE,
                    payload: { standortUrl, categoryUrl, productUrl, isExact, datECodePrefix, error },
                });
            }
        }
    };
};

export const setProductVariantId = ({ standortUrl, datECodePrefix, categoryUrl, productUrl, variantId }) => {
    return { type: SET_PRODUCT_VARIANT_ID, payload: { standortUrl, datECodePrefix, categoryUrl, productUrl, variantId } };
};
